import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef69d56e&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ef69d56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef69d56e",
  null
  
)

export default component.exports